import { KeenSliderInstance } from "keen-slider";
import { getSliderMaxIdx } from "../keen-slider-utils";

export default function keenNavigationPlugin(slider: KeenSliderInstance) {
    let sliderContent: HTMLElement, dotsWrapper: HTMLElement;

    function markup() {
        wrapperMarkup();
        dotMarkup();
    }

    function removeMarkups() {
        while (sliderContent.firstChild) sliderContent.parentNode.insertBefore(sliderContent.firstChild, sliderContent);
        removeElement(sliderContent);

        removeElement(dotsWrapper);
    }

    function removeElement(element: HTMLElement) {
        element?.remove();
    }

    function createElement(elementName: string, className: string) {
        const div = document.createElement(elementName);
        const classNames = className.split(" ");
        classNames.forEach((name) => div.classList.add(name));
        return div;
    }

    function wrapperMarkup() {
        sliderContent = createElement("div", "keen-slider__content");
        slider.container.parentNode.appendChild(sliderContent);

        sliderContent.appendChild(slider.container);
    }

    function dotMarkup() {
        const maxIdx = getSliderMaxIdx(slider);
        if (!maxIdx) {
            return;
        }

        dotsWrapper = createElement("ul", "keen-slider__dots");

        [...Array(maxIdx + 1).keys()].forEach((idx) => {
            const dot = createElement("li", "keen-slider__dot");
            dot.addEventListener("click", () => slider.moveToIdx(idx));
            dotsWrapper.appendChild(dot);
        });
        sliderContent.parentNode.appendChild(dotsWrapper);
    }

    function updateClasses() {
        const { rel } = slider.track.details;

        if (dotsWrapper?.children.length) {
            Array.from(dotsWrapper.children).forEach(function (dot, idx) {
                idx === rel
                    ? dot.classList.add("keen-slider__dot--active")
                    : dot.classList.remove("keen-slider__dot--active");
            });
        }
    }

    slider.on("created", () => {
        markup();
        updateClasses();
    });
    slider.on("optionsChanged", () => {
        removeMarkups();
        markup();
        updateClasses();
    });
    slider.on("slideChanged", () => {
        updateClasses();
    });
    slider.on("destroyed", () => {
        removeMarkups();
    });
}
